(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3308],{

/***/ 7150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);




const AutocompleteDropdown = (param)=>{
    let { display =false , className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("autocomplete__dropdown", display && "autocomplete__dropdown--show", className),
        ...props
    });
};
AutocompleteDropdown.propTypes = {
    display: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (AutocompleteDropdown);


/***/ }),

/***/ 7511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);




const AutocompleteDropdownGroup = (param)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("autocomplete-dropdown__group", className),
        ...props
    });
};
AutocompleteDropdownGroup.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (AutocompleteDropdownGroup);


/***/ }),

/***/ 36219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);




const AutocompleteDropdownGroupLabel = (param)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("autocomplete-dropdown__group-label", className),
        ...props
    });
};
AutocompleteDropdownGroupLabel.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (AutocompleteDropdownGroupLabel);


/***/ }),

/***/ 52004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);




const AutocompleteDropdownItem = (param)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("autocomplete-dropdown__item", className),
        ...props
    });
};
AutocompleteDropdownItem.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (AutocompleteDropdownItem);


/***/ }),

/***/ 27367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const AutocompleteDropdownItemLink = (param)=>/*#__PURE__*/ {
    let { Tag =_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z , className ="" , href , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("autocomplete-dropdown__item-link", className),
        href: href,
        ...props
    });
};
AutocompleteDropdownItemLink.propTypes = {
    Tag: prop_types__WEBPACK_IMPORTED_MODULE_4__.elementType,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (AutocompleteDropdownItemLink);


/***/ }),

/***/ 20466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _InputGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88554);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61672);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6470);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67924);







const AutocompleteField = (param)=>/*#__PURE__*/ {
    let { className ="" , iconName ="search" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_InputGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("autocomplete__field", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InputGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Prepend */ .Z.Prepend, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    name: iconName
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InputGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Field */ .Z.Field, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    type: "search",
                    ...props
                })
            })
        ]
    });
};
AutocompleteField.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    iconName: _Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"].propTypes.name */ .Z.propTypes.name
};
/* harmony default export */ __webpack_exports__["Z"] = (AutocompleteField);


/***/ }),

/***/ 67909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Autocomplete_Loader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var sx = __webpack_require__(23720);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Loader/Loader.js





const Loader = (param)=>{
    let { Tag ="div" , color ="black" , size ="m" , className =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag, {
        className: (0,classes/* classes */.S)("loader", "loader-".concat(size), "loader-color-".concat(color), "loader--overlay", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                className: "loader__part"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                className: "loader__part"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                className: "loader__part"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                className: "loader__part"
            })
        ]
    });
};
Loader.propTypes = {
    Tag: prop_types.elementType,
    color: (0,prop_types.oneOf)([
        "black",
        "white",
        "gray",
        "red",
        "green",
        "1",
        "2",
        "3",
        "4",
        "5"
    ]),
    size: sx/* fontSizePropTypes */.Gk,
    className: prop_types.string
};
/* harmony default export */ var Loader_Loader = (Loader);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Loader/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/Loader.js





const AutocompleteLoader = (param)=>/*#__PURE__*/ {
    let { wrapperClassName ="" , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("autocomplete__loader", wrapperClassName),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_Loader, {
            size: "s",
            color: "2",
            ...props
        })
    });
};
AutocompleteLoader.propTypes = {
    wrapperClassName: prop_types.string
};
/* harmony default export */ var Autocomplete_Loader = (AutocompleteLoader);


/***/ }),

/***/ 40539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Autocomplete_Autocomplete; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/Autocomplete.js




const Autocomplete = (param)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("autocomplete", className),
        ...props
    });
};
Autocomplete.propTypes = {
    className: prop_types.string
};
/* harmony default export */ var Autocomplete_Autocomplete = (Autocomplete);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/index.js



/***/ }),

/***/ 71125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ BreadcrumbItemLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);



const BreadcrumbItemLink = (param)=>{
    let { href , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        href: href,
        className: "breadcrumbs__item-link",
        ...props,
        children: children
    });
};
BreadcrumbItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
const BreadcrumbItem = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "breadcrumbs__item",
        ...props
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);


/***/ }),

/***/ 78086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Breadcrumbs_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/Breadcrumbs.js




const Breadcrumbs = (param)=>{
    let { className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("breadcrumbs", className),
        children: children
    });
};
Breadcrumbs.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/index.js



/***/ }),

/***/ 50410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6949);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23720);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroDescription = (param)=>{
    let { align , color ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_5__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__description", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_5__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroDescription.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_5__/* .textAlignPropTypes */ .g4,
    color: _props_sx__WEBPACK_IMPORTED_MODULE_5__/* .colorPropTypes */ .AK,
    ..._Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroDescription);


/***/ }),

/***/ 91319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroTitle = (param)=>{
    let { align , color , className ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h1",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__title", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroTitle.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_4__/* .textAlignPropTypes */ .g4,
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroTitle);


/***/ }),

/***/ 69591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Hero_Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Hero.js









const Hero = (param)=>{
    let { align ="center" , children , color ="black--02" , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , backgroundImage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)("section-hero", align && "section-hero-text-".concat(align), color && "section-hero-color-".concat(color), "".concat(backgroundImage ? "section-hero-custom-background" : ""), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        style: {
            ...backgroundImage && {
                backgroundImage: "url(".concat(backgroundImage, ")")
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    children: children
                })
            })
        })
    });
};
Hero.propTypes = {
    align: props_sx/* textAlignPropTypes */.g4,
    className: prop_types.string,
    children: prop_types.node.isRequired,
    color: (0,prop_types.oneOf)([
        "1",
        "1--light",
        "2",
        "3",
        "4",
        "5",
        "6",
        "white",
        "black--02",
        "transparent",
        "gradient"
    ]),
    backgroundImage: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js



/***/ }),

/***/ 6470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Input_Input; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/invariant.js
/**
 * @param {boolean} condition
 * @param {string} message
 */ const invariant = (condition, message)=>{
    if (false) {}
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Input/Input.js










const Input = (param)=>{
    let { type ="text" , hideInputNumberArrows =true , maxLength =250 , error , className , forwardRef , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    invariant(/^(button|reset|submit)$/.test(type), "Use <Button /> component instead of Input");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
        type: type,
        maxLength: maxLength,
        ref: forwardRef,
        className: (0,classes/* classes */.S)("field__input", "field__".concat(type), type === "number" && hideInputNumberArrows && "hidden-arrows", error && "field--error", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Input.propTypes = {
    type: (0,prop_types.oneOf)([
        "email",
        "file",
        "hidden",
        "number",
        "password",
        "range",
        "search",
        "tel",
        "text",
        "url"
    ]),
    className: prop_types.string,
    maxLength: prop_types.number,
    error: (0,prop_types.oneOfType)([
        prop_types.bool,
        prop_types.string,
        prop_types.node
    ]),
    hideInputNumberArrows: prop_types.bool,
    forwardRef: forward_ref/* default */.Z,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Input_Input = ((0,pureFC/* default */.Z)(Input));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Input/index.js



/***/ }),

/***/ 88554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ InputGroup_InputGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/InputGroup/InputGroup.js





const InputGroupPrepend = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "input-group-prepend",
        children: children
    });
};
InputGroupPrepend.propTypes = {
    children: prop_types.node.isRequired
};
const InputGroupAppend = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "input-group-append",
        children: children
    });
};
InputGroupAppend.propTypes = {
    children: prop_types.node.isRequired
};
const InputGroupField = (param)=>{
    let { children  } = param;
    return children;
};
InputGroupField.propTypes = {
    children: prop_types.node.isRequired
};
const InputGroup = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("input-group", className),
        children: children
    });
};
InputGroup.propTypes = {
    children: prop_types.node.isRequired,
    className: prop_types.string
};
const InputGroupButton = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,jsx_runtime.jsx)(Button/* default */.Z, {
        styleType: "input-group",
        size: "s",
        ...props
    });
};
InputGroupButton.propTypes = {
    ...Button/* default.propTypes */.Z.propTypes
};
InputGroup.Prepend = InputGroupPrepend;
InputGroup.Append = InputGroupAppend;
InputGroup.Field = InputGroupField;
InputGroup.Button = InputGroupButton;
/* harmony default export */ var InputGroup_InputGroup = (InputGroup);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/InputGroup/index.js



/***/ }),

/***/ 72989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93512);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42866);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6949);
/* harmony import */ var _r1_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12985);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18981);














const Title = (param)=>/*#__PURE__*/ {
    let { className ="" , color , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        Tag: "h2",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__title", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mb: 0,
            mt: 0
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
Title.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const TitleV2 = (param)=>/*#__PURE__*/ {
    let { className ="" , color , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        Tag: "h2",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__title-v2", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mb: 0,
            mt: 0
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
TitleV2.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const DescriptionV2 = (param)=>/*#__PURE__*/ {
    let { className ="" , color , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    }  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__description-v2", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            fontSize: "l",
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mt: 4
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        children: children
    });
};
DescriptionV2.propTypes = {
    color: _props_sx__WEBPACK_IMPORTED_MODULE_9__/* .colorPropTypes */ .AK,
    ..._Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"].propTypes */ .Z.propTypes
};
const Body = (param)=>/*#__PURE__*/ {
    let { children =null  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
Body.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_13__.node
};
const Action = (param)=>/*#__PURE__*/ {
    let { ActionComponent =_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        utility: {
            justify: "center"
        },
        spacing: {
            mt: 8
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
            sx: {
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActionComponent, {
                ...props,
                children: children
            })
        })
    });
};
Action.propTypes = {
    ActionComponent: prop_types__WEBPACK_IMPORTED_MODULE_13__.elementType,
    children: prop_types__WEBPACK_IMPORTED_MODULE_13__.node.isRequired
};
const LandingSimpleSection = (param)=>{
    let { className ="" , isBorderNone =false , bgColor , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , children , containerProps , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section", !isBorderNone && "landing-simple-section--border-bottom", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            bgColor
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(utility))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_r1_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            ...containerProps,
            children: children
        })
    });
};
LandingSimpleSection.propTypes = {
    bgColor: _props_sx__WEBPACK_IMPORTED_MODULE_9__/* .colorPropTypes */ .AK,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_13__.bool,
    containerProps: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.shape)({
        sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        md: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        center: prop_types__WEBPACK_IMPORTED_MODULE_13__.bool
    }),
    ..._Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const SectionLabel = (param)=>{
    let { utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__label", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)(spacing), className),
        children: children
    });
};
SectionLabel.propTypes = {
    ..._Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"].propTypes */ .Z.propTypes
};
LandingSimpleSection.Label = SectionLabel;
LandingSimpleSection.Title = Title;
LandingSimpleSection.TitleV2 = TitleV2;
LandingSimpleSection.DescriptionV2 = DescriptionV2;
LandingSimpleSection.Body = Body;
LandingSimpleSection.Action = Action;
/* harmony default export */ __webpack_exports__["Z"] = (LandingSimpleSection);


/***/ }),

/***/ 23069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const PageNavbarSearchMain = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: 9,
        ...props
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageNavbarSearchMain);


/***/ }),

/***/ 68646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const PageNavbarSearchSidebar = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: 3,
        className: "searchbar-field",
        ...props
    });
};
PageNavbarSearchSidebar.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (PageNavbarSearchSidebar);


/***/ }),

/***/ 59157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageNavbarSearch_PageNavbarSearch; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/PageNavbarSearch.js





const PageNavbarSearch = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        spacing: {
            py: 3
        },
        utility: {
            bgColor: "black--10"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                utility: {
                    align: {
                        items: "center"
                    },
                    justify: "center"
                },
                children: children
            })
        })
    });
};
PageNavbarSearch.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var PageNavbarSearch_PageNavbarSearch = (PageNavbarSearch);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/index.js



/***/ }),

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionTryForFree_SectionTryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/SectionTryForFree.js





const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__title",
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Action = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__action",
        children: children
    });
};
Action.propTypes = {
    children: prop_types.node.isRequired
};
const SectionTryForFree = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    children: children
                })
            })
        })
    });
};
SectionTryForFree.propTypes = {
    children: prop_types.node.isRequired
};
SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;
/* harmony default export */ var SectionTryForFree_SectionTryForFree = (SectionTryForFree);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js



/***/ }),

/***/ 35449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleTemplate_SimpleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/Panel.js





const Panel = (param)=>{
    let { className ="" , shadow , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        className: (0,classes/* classes */.S)("panel", shadow && "panel--shadow", className),
        ...props
    });
};
Panel.propTypes = {
    shadow: prop_types.bool,
    ...Block/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var Panel_Panel = (Panel);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/SimpleTemplate.js










const SimpleTemplate = (param)=>{
    let { cellWidth =8 , mdCellWidth =10 , paddingTop ="pt-9 pt-9--md" , paddingBottom ="pb-18 pb-18--md" , panel =true , panelPaddingY =16 , panelUtility ={
        ...props_utility/* utilityProps */.Gm
    } , children , bgColor =color/* bgColorBlack2 */.vk , className ="" , shadow =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(paddingTop, paddingBottom, !(utility && utility.bgColor) && bgColor, ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    md: mdCellWidth,
                    lg: cellWidth,
                    children: panel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel_Panel, {
                        shadow: shadow,
                        utility: panelUtility,
                        spacing: {
                            py: panelPaddingY
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                            mx: true,
                            px: true,
                            utility: {
                                justify: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 10,
                                children: children
                            })
                        })
                    }) : children
                })
            })
        })
    });
};
SimpleTemplate.propTypes = {
    shadow: prop_types.bool,
    cellWidth: prop_types.number,
    mdCellWidth: prop_types.number,
    paddingTop: prop_types.string,
    paddingBottom: prop_types.string,
    panel: prop_types.bool,
    panelPaddingY: prop_types.number,
    panelUtility: props_utility/* utilityPropTypes */.pQ,
    children: prop_types.node.isRequired,
    bgColor: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var SimpleTemplate_SimpleTemplate = (SimpleTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 37894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _fn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

const fallback = (handler)=>(fn)=>{
        if (typeof handler !== "function") return fn;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            const theHandler = (err)=>handler(err, ...args);
            try {
                const result = fn(...args);
                return (0,_fn__WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(result) ? result.catch(theHandler) : result;
            } catch (err) {
                return theHandler(err);
            }
        };
    };
/* harmony default export */ __webpack_exports__["Z"] = (fallback);


/***/ }),

/***/ 86594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export after */
/* harmony import */ var _fn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10455);
/* harmony import */ var _fn_pipe__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75833);


const after = (fn)=>(value)=>(0,_fn__WEBPACK_IMPORTED_MODULE_1__/* .isPromise */ .tI)(value) ? value.then(fn) : fn(value);
const then = (handler)=>(fn)=>{
        if (typeof handler !== "function") return fn;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (0,_fn_pipe__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(fn(...args), after((res)=>handler(res, ...args)));
        };
    };
/* harmony default export */ __webpack_exports__["Z"] = (then);


/***/ }),

/***/ 71970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dv": function() { return /* binding */ Left; },
  "O6": function() { return /* binding */ Right; },
  "tS": function() { return /* binding */ chain; },
  "Gs": function() { return /* binding */ extRightStrict; },
  "ew": function() { return /* binding */ tapLeft; }
});

// UNUSED EXPORTS: LEFT, RIGHT, RightFrom, apply, biChain, biMap, biTap, chainLeft, extLeft, extLeftStrict, extRight, fromNullable, isLeft, isRight, leftFrom, map, mapLeft, match, of, strict, tap, validate

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/fn/toStr.js
const toStr_toStr = (value)=>typeof value === "symbol" ? value.toString() : "".concat(value);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/either/index.js

const LEFT = Symbol("__left__");
const RIGHT = Symbol("__right__");
const throwTypeError = (msg)=>{
    throw new TypeError(msg);
};
const Left = (error)=>({
        tag: LEFT,
        error
    });
const leftFrom = (fn)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Left(fn(...args));
    };
Left.from = leftFrom;
const Right = (result)=>({
        tag: RIGHT,
        result
    });
const RightFrom = (fn)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Right(fn(...args));
    };
Right.from = RightFrom;
const fromNullable = (left)=>(value)=>value == null ? Left(left) : Right(value);
const of = (/* unused pure expression or super */ null && (Right));
const isLeft = (either)=>{
    return (either === null || either === void 0 ? void 0 : either.tag) === LEFT;
};
const isRight = (either)=>{
    return (either === null || either === void 0 ? void 0 : either.tag) === RIGHT;
};
const extLeft = (either)=>isLeft(either) ? either.error : undefined;
Left.extract = extLeft;
const extRight = (either)=>isRight(either) ? either.result : undefined;
Right.extract = extRight;
const chain = (chainFn)=>(either)=>isRight(either) ? chainFn(extRight(either)) : either;
const chainLeft = (chainFn)=>(either)=>isLeft(either) ? chainFn(extLeft(either)) : either;
const biChain = (leftChainFn, rightChainFn)=>(either)=>// prettier-ignore
        isRight(either) ? rightChainFn(extRight(either)) : isLeft(either) ? leftChainFn(extLeft(either)) : /* otherwise */ throwTypeError("".concat(toStr(either), " is not an either Left or Right"));
const extRightStrict = (either)=>isRight(either) ? either.result : throwTypeError("".concat(toStr_toStr(either), " is not Right"));
const extLeftStrict = (either)=>isLeft(either) ? either.error : throwTypeError("".concat(toStr_toStr(either), " is not Left"));
const strict = {
    extLeft: extLeftStrict,
    extRight: extRightStrict
};
const match = (onLeft, onRight)=>(either)=>// prettier-ignore
        isLeft(either) ? onLeft(extLeft(either)) : isRight(either) ? onRight(extRight(either)) : /* otherwise */ throwTypeError("".concat(toStr(either), " is not an either Left or Right"));
const tap = (effect)=>(either)=>{
        if (isRight(either)) effect(extRight(either));
        return either;
    };
const tapLeft = (effect)=>(either)=>{
        if (isLeft(either)) effect(extLeft(either));
        return either;
    };
const biTap = (leftEffect, rightEffect)=>(either)=>{
        if (isRight(either)) rightEffect(extRight(either));
        if (isLeft(either)) leftEffect(extLeft(either));
        return either;
    };
const map = (mapper)=>(either)=>// prettier-ignore
        isRight(either) ? Right(mapper(extRight(either))) : either;
const mapLeft = (mapper)=>(either)=>// prettier-ignore
        isLeft(either) ? Left(mapper(extLeft(either))) : either;
const biMap = (leftMapper, rightMapper)=>(either)=>// prettier-ignore
        isRight(either) ? Right(rightMapper(extRight(either))) : isLeft(either) ? Left(leftMapper(extLeft(either))) : /* otherwise */ throwTypeError("".concat(toStr(either), " is not an either Left or Right"));
const apply = (argEither)=>chain((fn)=>isLeft(argEither) ? argEither //
         : Right(fn(extRight(argEither))));
const validate = (validator)=>chain((value)=>{
        const validationResult = validator(value);
        return isLeft(validationResult) ? validationResult : Right(value);
    });


/***/ }),

/***/ 55161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ createAndRaise; }
/* harmony export */ });
/**
 * Creates a function that throws Error created with errorFactory
 *
 * @type {<A extends any[], E extends Error>(errorFactory: (...args: A) => E) => (...args: A) => never}
 */ const createAndRaise = (errorFactory)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        throw errorFactory(...args);
    };


/***/ }),

/***/ 77915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

/**
 * Type `SyncType<T>` - Type extracts type packed into the Promise
 *
 * @template T
 * @typedef {T extends Promise<infer Packed> ? Packed : T} SyncType
 */ const packToBuf = (buffer, field)=>(result)=>{
        // eslint-disable-next-line no-param-reassign
        buffer[field] = result;
        return buffer;
    };
const resolveToBuffer = (param)=>{
    let [field, resolver] = param;
    return (args, buffer)=>{
        try {
            const result = resolver(...args);
            const pack = packToBuf(buffer, field);
            return (0,___WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(result) ? result.then(pack) : pack(result);
        } catch (err) {
            return Promise.reject(err);
        }
    };
};
const resolversWrapper = (resolvers)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const buffer = {};
        const promises = resolvers.map((0,___WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(args, buffer));
        return Promise.all(promises).then(()=>buffer);
    };
const prepareResolvers = (param)=>{
    let [field, resolver] = param;
    return resolveToBuffer([
        field,
        (0,___WEBPACK_IMPORTED_MODULE_0__/* .ensureFunc */ .KX)(resolver, ()=>resolver)
    ]);
};
/**
 * Creates new functions that returns Promise resolving to an object with
 * values returned by functions specified for correspondent fields of argument
 * object
 *
 * @example
 * const fn = propsResolver({
 * 	x: () => 1,
 *  y: () => 2,
 * });
 * fn().then(console.log); // prints: { x: 1, y: 2 }
 *
 * @type {
 	<
		A extends any[],
		M extends { [p in string]: (...args: any[]) => any }
	>(resolversMap: M) => (...args: A) => Promise<{ [k in keyof M]: SyncType<ReturnType<M[k]>> }>
 }
 */ const propsResolver = (resolversMap)=>resolversWrapper(Object.entries(resolversMap).map(prepareResolvers));
/* harmony default export */ __webpack_exports__["Z"] = (propsResolver);


/***/ }),

/***/ 71195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ http_client; }
});

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/http-client/headers.js
/** @type {(name: string) => (response: Response) =>string | null} */ const header = (name)=>(response)=>response.headers.get(name);
const contentType = header("Content-Type");

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/http-client/index.js
/** @typedef {import("./types").Result} Result */ /** @typedef {import("./types").FetchOptions} FetchOptions */ /** @typedef {import("./types").IHttpClient} IHttpClient */ 
/** @type {(baseUrl: string, url: string, query?: {}) => URL} */ const buildUrl = (baseUrl, url, query)=>Object.assign(new URL(url, baseUrl), query != null ? {
        search: new URLSearchParams(query)
    } : {});
const defaultContentType = (data)=>// prettier-ignore
    data === undefined ? undefined : typeof data === "string" ? "text/plain" : "application/json";
/** @type {(data: any) => string | undefined} */ const serialize = (data)=>typeof data !== "string" && data !== undefined ? JSON.stringify(data) : data;
/** @type {(response: Response) => Promise<Result>} */ const parseResponse = (response)=>(/json/i.test(contentType(response)) ? response.json().catch((error)=>({
            error
        })) //
     : response.text()).then((body)=>({
            ok: response.ok,
            status: response.status,
            statusText: response.statusText,
            body
        }));
/** @type {(fetch: FetchFn, options: FetchOptions & { baseUrl?: string }) => IHttpClient} */ const httpClient = function(fetchFn) {
    let { baseUrl , ...baseOptions } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const send = function(method, url) {
        let { data , ...options } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return fetchFn(buildUrl(baseUrl, url, options.query).href, {
            ...baseOptions,
            ...options,
            method,
            headers: {
                ...data !== undefined ? {
                    "content-type": defaultContentType(data)
                } : {},
                ...baseOptions.headers,
                ...options.headers
            },
            ...data !== undefined ? {
                body: serialize(data)
            } : {}
        }).then(parseResponse);
    };
    const sendEmpty = (method)=>send.bind(undefined, method);
    const sendData = (method)=>(url, data, options)=>send(method, url, {
                ...options,
                data
            });
    return {
        get: sendEmpty("GET"),
        post: sendData("POST"),
        put: sendData("PUT"),
        patch: sendData("PATCH"),
        delete: sendEmpty("DELETE")
    };
};
/* harmony default export */ var http_client = (httpClient);


/***/ }),

/***/ 66651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

class ApplicationError extends Error {
    toSerializable() {
        const { name , message , code , stack , originalError , tags  } = this;
        return {
            name,
            message,
            code,
            stack: typeof stack === "string" ? stack.split("\n") : stack,
            originalError: originalError ? {
                name: originalError.name,
                code: originalError.code,
                message: originalError.message
            } : null,
            tags
        };
    }
    toJSON() {
        return this.toSerializable();
    }
    constructor(originalError, code = 500, message = ApplicationError.defaultMessage[code], tags = null){
        super(message);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "name", "ApplicationError");
        this.code = code;
        this.originalError = originalError;
        this.stack = (originalError === null || originalError === void 0 ? void 0 : originalError.stack) || new Error().stack;
        this.tags = tags;
    }
}
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "defaultMessage", {
    400: "Bad Request",
    401: "Not Authorized",
    403: "Not Permitted",
    404: "Not Found",
    500: "Internal Error"
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "of", (error)=>error instanceof ApplicationError ? error : new ApplicationError(error, error.code || 500, error.message));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "BadRequest", ()=>new ApplicationError(null, 400));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotAuthorized", ()=>new ApplicationError(null, 401));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotFound", ()=>new ApplicationError(null, 404));
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationError);


/***/ }),

/***/ 4354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ withForceError; }
/* harmony export */ });
/* unused harmony export throwError */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10455);
/* harmony import */ var _url_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89333);
/* harmony import */ var _displayName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75511);
/* harmony import */ var _ApplicationError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66651);







const getCurrentPath = (param)=>{
    let { asPath  } = param;
    return asPath;
};
const getQueryParam = function() {
    let paramName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "throw";
    return (pathname)=>(0,_url_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(pathname)[paramName];
};
const parseErrorParams = (wsParamValue)=>/(-?\d+)-([^-].*)/.exec(wsParamValue) || [];
const normalizeParams = (param)=>{
    let [, code, message] = param;
    return [
        code && parseInt(code, 10),
        message
    ];
};
const getErrorParamsFromPath = (paramName)=>(0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(normalizeParams, parseErrorParams, getQueryParam(paramName), getCurrentPath);
const throwError = (getInitialProps, paramName)=>(context)=>{
        const [code, message] = getErrorParamsFromPath(paramName)(context);
        if (code == null) {
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .isFunc */ .Wl)(getInitialProps) ? getInitialProps(context) : {
                __throwError: true
            };
        }
        if (code < 0) throw new _ApplicationError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(new Error("Server Side: ".concat(message)), -code, "Server Side: ".concat(message));
        return {
            errorToThrow: {
                code,
                message
            }
        };
    };
/** @type {(paramName: string) => <P extends {}>(Component: React.Component<P>) => React.FC<P>} */ const withForceErrorHOC = (paramName)=>(Component)=>{
        const ComponentWithThrowError = (param)=>{
            let { errorToThrow , ...props } = param;
            if (errorToThrow && "object" !== "undefined") throw new _ApplicationError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(new Error("Client Side: ".concat(errorToThrow.message)), errorToThrow.code, "Client Side: ".concat(errorToThrow.message));
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            });
        };
        ComponentWithThrowError.propTypes = {
            ...Component.propTypes,
            errorToThrow: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.shape)({
                code: prop_types__WEBPACK_IMPORTED_MODULE_5__.number,
                message: prop_types__WEBPACK_IMPORTED_MODULE_5__.string
            })
        };
        ComponentWithThrowError.displayName = (0,_displayName__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("withForceError", Component);
        ComponentWithThrowError.getInitialProps = throwError(Component.getInitialProps, paramName);
        return ComponentWithThrowError;
    };
const withForceError = withForceErrorHOC;


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84154);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ }),

/***/ 42202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable no-console */ 
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    data: null,
    container: null,
    run: (fn)=>{
        console.warn("Cannot run function in di-context, due it is not provided");
        console.log({
            fn: fn && (fn.name || fn.toString())
        });
    }
}));


/***/ }),

/***/ 91491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DiPageHoC_DiPageHoC; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/displayName.js
var displayName = __webpack_require__(75511);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/context.js
var context = __webpack_require__(18018);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hoc-merge-props.js

const merge = (propName)=>(props, value)=>({
            ...props,
            [propName]: {
                value,
                toJSON: ()=>null
            }
        });
const extract = (propName)=>{
    return (props)=>{
        var ref;
        const value = (ref = props[propName]) === null || ref === void 0 ? void 0 : ref.value;
        const propsCopy = {
            ...props
        };
        delete propsCopy[propName];
        return [
            value,
            propsCopy
        ];
    };
};
const getPropsAndMerge = (mergeFn)=>function(getProps, value) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        const props = (0,fn/* isFunc */.Wl)(getProps) ? getProps(...args) : null;
        return (0,fn/* isPromise */.tI)(props) ? props.then((resolved)=>mergeFn(resolved, value)) : mergeFn(props, value);
    };
const NotSerializableProp = (propName)=>{
    const ownMerge = merge(propName);
    return {
        merge: ownMerge,
        extract: extract(propName),
        getPropsAndMerge: getPropsAndMerge(ownMerge)
    };
};
/* harmony default export */ var hoc_merge_props = (NotSerializableProp);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/DiPageHoC.js






const { merge: DiPageHoC_merge , extract: DiPageHoC_extract  } = hoc_merge_props("container");
const useIsomorphicEffect =  false ? 0 : react.useLayoutEffect;
const DiPageHoC = (createContainer)=>(Page)=>{
        const DiPage = (pageProps)=>{
            const [containerFromProps, data] = DiPageHoC_extract(pageProps);
            const container = (0,react.useMemo)(()=>containerFromProps !== null && containerFromProps !== void 0 ? containerFromProps : createContainer(null), []);
            const [state, setState] = (0,react.useState)(data);
            const stateRef = (0,react.useRef)();
            stateRef.current = state;
            const updateState = (0,react.useCallback)((statePatch)=>{
                const newState = typeof statePatch === "function" ? statePatch(stateRef.current) : statePatch;
                stateRef.current = newState;
                setState(newState);
            }, [
                setState
            ]);
            useIsomorphicEffect(()=>{
                if (state === data) return;
                updateState(data);
            }, [
                pageProps
            ]);
            const run = react.useCallback((fn)=>fn(container, stateRef.current, run, updateState), [
                container
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
                value: {
                    run,
                    data: state,
                    container,
                    setState: updateState
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                    ...data
                })
            });
        };
        Object.assign(DiPage, Page); // copying all static props
        DiPage.displayName = (0,displayName/* default */.Z)("withDiContext", Page);
        DiPage.getInitialProps = (context)=>{
            const container = createContainer(context);
            const runGetInitProps = (fn)=>fn(context, container, runGetInitProps);
            const props = typeof Page.getInitialProps === "function" ? runGetInitProps(Page.getInitialProps) : null;
            return (0,fn/* isPromise */.tI)(props) ? props.then((resolved)=>DiPageHoC_merge(resolved, container)) : DiPageHoC_merge(props, container);
        };
        return DiPage;
    };
/* harmony default export */ var DiPageHoC_DiPageHoC = (DiPageHoC);


/***/ }),

/***/ 18018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _di_context_context__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _di_context_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42202);



/***/ }),

/***/ 74063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vi": function() { return /* reexport */ usePageData; },
  "Sr": function() { return /* reexport */ useRun; },
  "Su": function() { return /* reexport */ useServices; }
});

// UNUSED EXPORTS: default, useData, useExec

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/context.js
var DiPageHoC_context = __webpack_require__(18018);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/di-context/context.js
var di_context_context = __webpack_require__(42202);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/di-context/hooks.js



let deprecationWarning = ()=>{
    // eslint-disable-next-line no-console
    console.warn('useData hook is deprecated. Use "usePageData instead."');
    deprecationWarning = ()=>{};
};
const usePageData = function() {
    let selector = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fn/* idX */.Yr;
    return selector(react.useContext(di_context_context/* default */.Z).data);
};
const useData = (selector)=>{
    deprecationWarning();
    return usePageData(selector);
};
const useRun = (action)=>{
    const { run  } = react.useContext(di_context_context/* default */.Z);
    return (0,react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return run(action(...args));
    }, [
        action,
        run
    ]);
};
const useExec = (thunk, deps)=>{
    const { run  } = React.useContext(context);
    return useMemo(()=>run(thunk), deps);
};

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/hooks.js



const useServices = function() {
    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
        names[_key] = arguments[_key];
    }
    const { container  } = react.useContext(DiPageHoC_context/* default */.Z);
    return react.useMemo(()=>names.map((name)=>container[name]), names);
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/DiPageHoC.js + 1 modules
var DiPageHoC = __webpack_require__(91491);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/index.js




/***/ }),

/***/ 18092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hocs_NextPageWithServices; }
});

;// CONCATENATED MODULE: ./node_modules/true-di/esm/unique-stack.js
const _push = (stack, set) => (item) => {
    if (set.has(item))
        return [new Error('Duplicated item has been pushed to the stack.'), null];
    stack.unshift(item);
    set.add(item);
    return [null, item];
};
const _pop = (stack, set) => (expected) => {
    if (stack.length === 0) {
        return [new Error('Trying to extract item from the empty stack'), null];
    }
    const last = stack.shift();
    set.delete(last);
    return (expected === undefined || last === expected
        ? [null, last]
        : [new Error('Extracted item is not equal to expected one'), null]);
};
const UniqueStackApi = (stack, set) => ({
    push: _push(stack, set),
    pop: _pop(stack, set),
    get size() {
        return stack.length;
    },
    get items() {
        return stack.slice();
    },
});
const UniqueStack = () => UniqueStackApi([], new Set());
/* harmony default export */ var unique_stack = (UniqueStack);

;// CONCATENATED MODULE: ./node_modules/true-di/esm/create-instance.js

const call = (fn) => fn();
const createInstanceFactory = (factories, instances, stack = unique_stack(), initializers = []) => (container, name) => {
    if (instances.has(name))
        return instances.get(name);
    if (stack.push(name)[0] != null) {
        throw new Error('Cyclic dependencies couldn\'t be resolved.\n\n' +
            `Requested: ${name}\nResolution stack:\n\t${stack.items.join('\n\t')}`);
    }
    const itemFactory = factories[name];
    const [factory, initializer] = (Array.isArray(itemFactory) ? itemFactory : [itemFactory, null]);
    if (typeof factory !== 'function') {
        throw new Error(`Factory is not defined for name "${name}"`);
    }
    const instance = factory(container);
    instances.set(name, instance);
    if (typeof initializer === 'function') {
        initializers.push(() => initializer(instance, container, name));
    }
    if (stack.pop(name)[0] != null) {
        throw new Error('Not all dependencies resolved correctly.');
    }
    if (stack.size === 0) {
        initializers.forEach(call);
        initializers = [];
    }
    return instance;
};
/* harmony default export */ var create_instance = (createInstanceFactory);

;// CONCATENATED MODULE: ./node_modules/true-di/esm/utils/all-names.js
const allNames = (obj) => Object.getOwnPropertyNames(obj)
    .concat(Object.getOwnPropertySymbols(obj));
/* harmony default export */ var all_names = (allNames);

;// CONCATENATED MODULE: ./node_modules/true-di/esm/di-container.js




const $INSTANCES = Symbol('TRUE-DI::INSTANCES');
const itemsOf = (container) => assertExists(container[$INSTANCES], 'Argument is not a container');
const isReady = (container, name) => itemsOf(container).has(name);
const prepareAll = (container) => mapObject(container, name => container[name]);
const releaseAll = (container) => {
    itemsOf(container).clear();
};
const factoriesFrom = (container, names) => mapObject(container, name => () => container[name], names);
function diContainer(factories) {
    const instances = new Map();
    const createInstance = create_instance(factories, instances);
    const container = all_names(factories).reduce((containerObj, name) => Object.defineProperty(containerObj, name, {
        configurable: false,
        enumerable: Object.getOwnPropertyDescriptor(factories, name).enumerable,
        get: () => createInstance(container, name),
        set: (value) => {
            if (value != null) {
                throw new Error('Container does\'t allow to replace items');
            }
            instances.delete(name);
        },
    }), Object.create(Object.create(null, {
        [$INSTANCES]: {
            configurable: false, writable: false, enumerable: false, value: instances,
        },
    })));
    return container;
}
/* harmony default export */ var di_container = (diContainer);

;// CONCATENATED MODULE: ./node_modules/true-di/esm/index.js





/* harmony default export */ var esm = (di_container);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/DiPageHoC.js + 1 modules
var DiPageHoC = __webpack_require__(91491);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/NextPageWithServices.js


const createContainer = (pageServices, coreServices)=>(context)=>esm({
            globalContext: ()=>context,
            ...coreServices,
            ...pageServices
        });
const NextPageWithServices = (coreServices)=>(Page)=>(0,DiPageHoC/* default */.Z)(createContainer(Page.services, coreServices))(Page);
/* harmony default export */ var hocs_NextPageWithServices = (NextPageWithServices);


/***/ }),

/***/ 64350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37894);


/**
 * Catches the action exception and re-raizes
 * it into the React rendering context
 *
 * @type {<A extends any[], R>(action: (...args: A) => R) => (...args: A) => R}
 */ function useActionError(action) {
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (error) throw error;
    }, [
        error
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(setError)(action), [
        action
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useActionError);


/***/ }),

/***/ 99112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86594);
/* harmony import */ var _insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71970);
/* harmony import */ var _useUnmounted__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23740);




function useActionResult(formAction) {
    const unmounted = (0,_useUnmounted__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const [either, setResult] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_2__/* .Right */ .O6)());
    const updateResult = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((res)=>{
        if (unmounted.current) return;
        setResult(res);
    }, [
        setResult
    ]);
    const action = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(updateResult)(formAction), [
        formAction
    ]);
    const reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>updateResult((0,_insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_2__/* .Right */ .O6)()), [
        formAction
    ]);
    const error = _insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_2__/* .Left.extract */ .dv.extract(either);
    const result = _insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_2__/* .Right.extract */ .O6.extract(either);
    return [
        action,
        {
            error,
            result,
            reset
        }
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useActionResult);


/***/ }),

/***/ 44993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _useTracking__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59074);
/* harmony import */ var _hocs_DiPageHoC__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74063);
/* harmony import */ var _useActionError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64350);
/* harmony import */ var _useActionResult__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99112);




function useFormAction(formAction, endOn) {
    const [actionWithResult, { error , result , reset  }] = (0,_useActionResult__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hocs_DiPageHoC__WEBPACK_IMPORTED_MODULE_1__/* .useRun */ .Sr)(formAction));
    const [trackableAction, isLoading] = (0,_useTracking__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(actionWithResult, endOn);
    return [
        (0,_useActionError__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(trackableAction),
        {
            error,
            result,
            isLoading,
            reset
        }
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useFormAction);


/***/ }),

/***/ 23740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useIfMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useUniEffect =  false ? 0 : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
function useUnmounted() {
    const unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    useUniEffect(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    }, []);
    return unmountedRef;
}
function useIfMounted(fn, isUnmountedRef) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (isUnmountedRef.current) return undefined;
        return fn(...args);
    }, [
        fn,
        isUnmountedRef
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useUnmounted);


/***/ }),

/***/ 89333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11987);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97334);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(querystring__WEBPACK_IMPORTED_MODULE_1__);


const query = (path)=>querystring__WEBPACK_IMPORTED_MODULE_1___default().parse((0,url__WEBPACK_IMPORTED_MODULE_0__.parse)(path).query);
/* harmony default export */ __webpack_exports__["Z"] = (query);


/***/ }),

/***/ 59074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "av": function() { return /* binding */ CATCH; }
/* harmony export */ });
/* unused harmony exports FINALLY, THEN */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10455);
/* harmony import */ var _hooks_useUnmounted__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23740);



const FINALLY = "finally";
const THEN = "then";
const CATCH = "catch";
function useTracking(action) {
    let endOn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : FINALLY;
    const unmounted = (0,_hooks_useUnmounted__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const end = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((resOrErr)=>{
        if (!unmounted.current) {
            setLoading(false); // setting loading off
        }
        if (endOn === CATCH) throw resOrErr;
        return resOrErr;
    }, []);
    const trackedAction = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const result = action(...args);
        if (!(0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_2__/* .isPromise */ .tI)(result)) return result;
        setLoading(true);
        return result[endOn](end);
    }, [
        action
    ]);
    return [
        trackedAction,
        loading
    ];
}
/* harmony default export */ __webpack_exports__["ZP"] = (useTracking);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

}]);